import axiosInstance from "../axiosInterceptor";

export async function getPurchaseCourseById(id) {

    const response = await axiosInstance.get(`student/getPurchaseCourse/${id}`);
    const data = response?.data;
    return data;
}